module.exports = __webpack_public_path__ + "static/2-b85cea34a1708f67fcbafef43d813e9b.png";